<div *ngIf="hasContent" class="conflict-banner">
  <div
    *ngIf="conflicts.length > 0"
    class="conflict-banner__section conflict-banner__section--error"
  >
    <div class="conflict-banner__header">
      <i class="fas fa-exclamation-triangle"></i>
      <span>Conflitto: {{ conflicts.length }} prenotazione/i sovrapposta/e</span>
    </div>
    <ul class="conflict-banner__list">
      <li *ngFor="let r of conflicts">
        <strong>{{ customerLabel(r) }}</strong>
        — {{ r.dataInizio | date: 'dd/MM/yyyy' }} → {{ r.dataFine | date: 'dd/MM/yyyy' }}
      </li>
    </ul>
  </div>

  <div
    *ngIf="upcoming.length > 0"
    class="conflict-banner__section conflict-banner__section--warning"
  >
    <div class="conflict-banner__header">
      <i class="fas fa-clock"></i>
      <span>Prenotazioni imminenti (entro 14 giorni)</span>
    </div>
    <ul class="conflict-banner__list">
      <li *ngFor="let r of upcoming">
        <strong>{{ customerLabel(r) }}</strong>
        — inizio {{ r.dataInizio | date: 'dd/MM/yyyy' }}
      </li>
    </ul>
  </div>
</div>
